import {createMap} from './map';
import {initTeamCards, initTeamNav} from "./initTeamCards";
import {initNewsCarousel} from "./initNewsCarousel";
import {showNavOnScrollPosition} from "./showNavOnScrollPosition";
import {initProjectsTabs} from "./initProjectsTabs";
import {initMobileSlideContent} from "./initMobileSlideContent";
import {getBootstrapDeviceSize} from "./getBootstrapDeviceSize";
import {initProjectDetail} from "./projectDetail";

console.log("#### app.js ####");
window.bootstrap = Bootstrap;


const createMobileVH = () => {
    let lastValue = window.innerHeight;

    function setViewportHeight() {

        document.documentElement.style.setProperty('--mobile-100vh', `${window.innerHeight}px`);
    }

    window.addEventListener("load",setViewportHeight);
    //setViewportHeight();
    window.addEventListener('resize', () => {
        if(Math.abs(lastValue-window.innerHeight) > 200){
            lastValue = window.innerHeight;
            setViewportHeight();
        }

    });
}

const initMobileMenu = () => {
    Alpine.store('mobileMenu', {
        open: false,
        toggle() {
            this.open = !this.open;
        },
        init() {
            this.boundClose = this.close.bind(this);
            window.addEventListener('resize', this.boundClose);
        },
        close() {
            this.open = false;
        },
        destroy() {
            window.removeEventListener('resize', this.boundClose);
        }

    })
}


const initProjectsCards = () => {
    Alpine.data("projectsCards", () => ({
        activeTab: 'Alle', // Default active tab
        deviceSize: getBootstrapDeviceSize(),

        init(){
            this.initFakeCards();
        },

        initFakeCards(){
            window.addEventListener('resize', () => {
                this.deviceSize = getBootstrapDeviceSize();

            })
        },

        tabactive($e) {
            this.activeTab = $e.detail.selectedTab;
            this.$dispatch('showkategorie', {selectedTab: this.activeTab}, true);
        }
    }));

}


Alpine.data("frontScrollArrow", () => ({
        open: false, // Default active tab
        target:null,
        scroll(){

            window.scrollTo({
                top: this.target.clientHeight - document.getElementById('mainheader').clientHeight,
                behavior: 'smooth'
            });
        },
        init() {
            this.target = document.getElementById('startseiten_banner');
        }
    })
)

const initAlpineComponents = () => {
    let pageName = document.body.getAttribute('data-path').slice(1,-1);
    createMobileVH();

    if(pageName === ""){
        showNavOnScrollPosition();

    }
    if(pageName === "team"){
        initProjectsTabs();
        initTeamCards();
        initTeamNav();
    }
    if(pageName === "projekte" || pageName.startsWith("projekt")){
        initProjectsCards()
        initProjectsTabs();
        createMap();
    }

    if (pageName !== "projekte" && pageName.startsWith("projekt")) {
        initProjectDetail();
    }

    initNewsCarousel();
    initMobileMenu();
    initMobileSlideContent();

    Alpine.start();


}

const initBannerCarousel = () => {
    window.addEventListener('load', () => {

        const carouselElement = document.querySelector('#theCarousel');
        if (!carouselElement) {
            return;
        }

        const carousel = new bootstrap.Carousel(carouselElement, {
            wrap:true,
            autoplay:false,
            interval:false
        });

        setTimeout(()=>{
            setInterval(()=>{
                carousel.next();
            },6000)
        },0)

    });


}


$(document).ready(function () {
    // Assign Colorbox to elements
    initBannerCarousel();
    initAlpineComponents();

});


